import { Component, computed, inject, model, signal } from '@angular/core';
import { DrawerModule } from 'primeng/drawer';
import { InboxService } from '@app/core/inbox.service';
import { ButtonModule } from 'primeng/button';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { SelectButton } from 'primeng/selectbutton';
import { FormsModule } from '@angular/forms';
import { DbTable } from '@app/models/models.helpers';

@Component({
  selector: 'app-inbox-drawer',
  imports: [
    DrawerModule,
    ButtonModule,
    OverlayBadgeModule,
    SelectButton,
    FormsModule
  ],
  templateUrl: './inbox-drawer.component.html',
  styleUrl: './inbox-drawer.component.scss',
})
export class InboxDrawerComponent {
  visible = model.required<boolean>();
  inboxService = inject(InboxService);
  inboxFilter = signal<string>('Unread');

  inboxMessages = computed(() => {
    if (this.inboxFilter()  === 'Unread') {
      return this.inboxService.inbox().filter(message => message.status === 'UNREAD');
    }
    else {
      return this.inboxService.inbox();
    }
  });

  // async ngOnInit() {
  //   setTimeout(async () => {
  //     await this.testCreateInboxMessage();
  //     console.log('inbox messages', this.inboxMessages());
  //   }, 1000);
  // }

  // async testCreateInboxMessage() {
  //   const inboxItem: DbTable<'inbox_items'> = {
  //     id: '1',
  //     title: 'Test Message',
  //     description: 'This is a test message',
  //     action_key: 'VIEW_ORG_INVITATION',
  //     action_label: 'View',
  //     action_path: '/app/organizations/1/invitations/1',
  //     severity: 'PRIMARY',
  //     status: 'UNREAD',
  //     show_toast: true,
  //     user_id: this.inboxService.sessionService.user()?.id,
  //     topic: 'INVITATION',
  //     meta: {
  //       organization_id: '1',
  //       invitation_id: '1',
  //     },
  //     created_at: new Date().toISOString(),
  //     updated_at: new Date().toISOString(),
  //   };
  //   await this.inboxService.supabase.client.from('inbox_items').insert(inboxItem);
  // }

  onInboxDrawerHide() {
    this.inboxService.markAllAsRead();
    this.visible.set(false);
  }

  onInboxFilterChange(event: any) {
    this.inboxFilter.set(event.value);
  }

  async onClickMessage(message: DbTable<'inbox_items'>) {
    const didNavigate = await this.inboxService.handleClickAction(message, {
      markAsRead: true,
      markAsToasted: true,
    });
    if (didNavigate) {
      this.visible.set(false);
    }
  }
}
